import Link from 'next/link';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getDivisionName, getSelectedDivision, getFAQLink } from '@/helpers/utils/siteUtils';

const PdpTooltip = () => {
  const divisionCode = getSelectedDivision() ?? 'ZB';
  const brandName = getDivisionName(divisionCode)?.toLowerCase();

  return (
    <section>
      <p className="pb-3 text-sm font-semibold leading-3">{mapLocaleToMeaningfulFormat().pdpPricePerMonth}</p>
      <p className="text-sm font-normal leading-4">
        {mapLocaleToMeaningfulFormat().PPMcontent} See{' '}
        <Link
          href={
            divisionCode === 'ZD'
              ? getFAQLink(`/help-center/faq/${brandName}-terms`)
              : getFAQLink(`/help-center/faq/${brandName}-credit-terms`)
          }
          prefetch={false}
          target="_blank"
          className="underline"
        >
          {mapLocaleToMeaningfulFormat().ppmTnc}
        </Link>{' '}
        for details.
      </p>
    </section>
  );
};

export default PdpTooltip;
